class QuickAddButton extends HTMLButtonElement {
  constructor() {
    super();
    this.available = this.dataset.available;
    this.productId = this.dataset.productId;
    this.variantAvailable = this.dataset.available;
    this.associatedInput = this.previousElementSibling;
  }

  updateVariantId(id) {
    this.associatedInput.value = id;
  }

  // Fix for button position bug. Resets quick add button animation after new page content is loaded.
  resetAnimation() {
    const productForm = this.parentElement.parentElement;
    productForm.style.transform = "none";
    productForm.style.transform = "translateY(100%);";
  }

  handleButtonText(variantIsAvailable) {
    const textAvailable = this.querySelector(".quick-add__submit--available");
    const textUnavailable = this.querySelector(
      ".quick-add__submit--unavailable"
    );

    if (variantIsAvailable === "true") {
      this.removeAttribute("disabled");
      textUnavailable.classList.add("hidden");
      textAvailable.classList.remove("hidden");
    } else {
      this.disabled = true;
      textUnavailable.classList.remove("hidden");
      textAvailable.classList.add("hidden");
    }
  }
}

if (!customElements.get("quick-add-button")) {
  customElements.define("quick-add-button", QuickAddButton, {
    extends: "button",
  });
}
